// Vue.prototype.$toast (nastaveno Vue.use(Toast, ...) v main.js) je jediná sdílená instance vue-toastification - přístup mimo komponenty (utils/fetch.js, main.js safety-net), ne nová paralelní instance přes createToastInterface().
import Vue from 'vue';
import {flags} from '@/config/featureFlags';

export function toastError(message) {
    // console.error vzdy (diagnostika), vizualni toast jen pokud hrac kategorii "Chyby" nevypnul v Options.
    console.error('[toast]', message);
    if (flags.notifyErr === false) {
        return;
    }
    if (Vue.prototype.$toast) {
        Vue.prototype.$toast.error(message);
    }
}
